"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SINGLE_CASE = exports.GROUP = void 0;
//@ts-nocheck
exports.GROUP = {
    content: [
        {
            id: 14752,
            caseRuns: [
                {
                    case_id: 14752,
                    case_status: "MANUAL",
                    process_instance_id: 16765,
                    case_encounter_id: 10256,
                    process_status: "At Coder",
                    run_type: "Addendum",
                    primary_process_indicator: true,
                    source_type: "HL7",
                    service_line: "Radiology",
                    tenant_code: "MGH",
                    tenant_name: "Massachusetts General Hospital",
                    tenant_timezone: "America/New_York",
                    health_system_code: "PHS",
                    patient_id: 204001,
                    patient_name: "SCENARIO14, JESSICA",
                    date_of_birth: "1981-08-18",
                    patient_gender: "F",
                    patient_identifier: {
                        number: "934938",
                        issuer: "EPIC",
                        type: "PMRN"
                    },
                    visit_number: {
                        number: "3305157800",
                        issuer: "EPIC",
                        type: "VISIT_NUMBER"
                    },
                    account_number: {
                        number: "6122578737",
                        issuer: null,
                        type: null
                    },
                    patient_class: "OUTPATIENT",
                    patient_type: null,
                    reason_for_visit: "*Ankle pain, osteochondral lesion suspected, neg xray",
                    primary_insurance: null,
                    primary_insurance_category: null,
                    encounter_identifier: {
                        number: "3305157800-2021-05-27-261142",
                        issuer: "CMX",
                        type: "ENCOUNTER_NUMBER"
                    },
                    exam_description: "MRI ANKLE WITHOUT CONTRAST (RIGHT)",
                    point_of_care: "MGH_IMGMRNS",
                    place_of_service: "MGDAN",
                    order_control: "RE",
                    order_number: {
                        number: "673003700",
                        issuer: "EPC",
                        type: "ORDER_NUMBER"
                    },
                    order_placer_number: {
                        number: "673003700",
                        issuer: "EPC",
                        type: "ORDER_NUMBER"
                    },
                    order_filler_number: {
                        number: "E15646500",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    ordering_provider_name: "CHIODO, CHRISTOPHER",
                    ordering_provider_specialty: null,
                    ordering_provider_number: {
                        number: "1002728",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    primary_clinical_identifier: {
                        number: "E15646500",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    division: "MGDAN",
                    exam_code: "MR.MS.ANK-/R",
                    body_region: "Lower Extremity",
                    procedure_type: "Magnetic Resonance",
                    procedure_type_category: "MR",
                    customer_automation_decision: null,
                    date_of_service: "2021-05-27",
                    datetime_of_service: "2021-05-27 11:43:14 EDT",
                    exam_date: null,
                    exam_datetime: null,
                    result_status: "C",
                    billing_location: "MGDAN",
                    billing_area: null,
                    billing_provider_specialty: null,
                    billing_provider_name: "ROSENTHAL, DANIEL",
                    billing_provider_number: {
                        number: "1001657",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    billing_provider_assistant_name: null,
                    billing_provider_assistant_number: null,
                    scheduling_department: "MGH IMG MR NS",
                    scheduling_department_code: "MGH_IMGMRNS",
                    resource_name: "MGH MR1NS",
                    resource_code: "MR1NS",
                    relevant_clinical_info: null,
                    placer_field_2: null,
                    work_queue_name: "MR UPPER/LOWER EXT JOINT",
                    billing_patient_identifier: null,
                    attending_provider_specialty: null,
                    attending_provider_name: null,
                    attending_provider_number: null,
                    referring_provider_specialty: null,
                    referring_provider_name: "CHIODO, CHRISTOPHER",
                    referring_provider_number: {
                        number: "1002728",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    rendering_provider_specialty: null,
                    rendering_provider_name: "ROSENTHAL, DANIEL",
                    rendering_provider_number: {
                        number: "1001657",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    admission_datetime: null,
                    discharge_datetime: null,
                    performing_provider_specialty: null,
                    performing_provider_name: null,
                    performing_provider_number: null,
                    service_provider_specialty: null,
                    service_provider_name: null,
                    service_provider_number: null,
                    patient_primary_facility: null,
                    service: null,
                    transaction_id: null,
                    sending_facility: null,
                    claims_edit_enabled_indicator: null,
                    tenant_insurance_plan_id: null,
                    tenant_insurance_plan_text: null,
                    tenant_insurance_payer_id: null,
                    tenant_insurance_payer_name: null,
                    tenant_insurance_payer_number: null,
                    tenant_medicare_contractor: null,
                    cmx_insurance_plan_text: null,
                    cmx_insurance_payer_id: null,
                    cmx_mapped_payer_number: null,
                    cmx_payer_group_name_property_name: null,
                    cmx_payer_category_property_name: null,
                    claims_edit_indicator: null,
                    cci_edit_indicator: null,
                    medicare_jurisdiction: null,
                    medicare_contractor: null,
                    requires_medicaid_cci_edits_indicator: null,
                    requires_cms_cci_edits_indicator: null,
                    requires_ncd_edits_indicator: null,
                    requires_lcd_edits_indicator: null,
                    requires_commercial_edits_indicator: null,
                    requires_mln_edits_indicator: null,
                    requires_article_edits_indicator: null,
                    requires_cms_manual_edits_indicator: null,
                    requires_transmittal_manual_edits_indicator: null,
                    claims_editor_payer_id: null,
                    claims_editor_payer_name: null,
                    claims_editor_issues: null,
                    cci_editor_issues: null,
                    custom_values: { routing: null },
                    mappings: [],
                    artifacts: [],
                    notes: [],
                    case_created_datetime: "2021-05-28 11:14:35 EDT",
                    process_instance_created_datetime: "2021-05-28 11:14:35 EDT",
                    exclusion_datetime: "2021-05-28 11:15:38 EDT",
                    prediction_start_datetime: null,
                    added_to_batch_datetime: null,
                    response_from_batch_datetime: null,
                    prediction_end_datetime: null,
                    automation_decision_datetime: "2021-05-28 11:15:38 EDT",
                    send_to_coder_datetime: null,
                    received_from_coder_datetime: null,
                    send_to_billing_datetime: null,
                    process_instance_completed_datetime: null,
                    case_completed_datetime: null,
                    patient_age: null,
                    prevent_billing_indicator: false,
                    prevent_send_to_coder_indicator: false,
                    automated_indicator: false,
                    route_to_predict: false,
                    route_to_billing: false,
                    route_to_qa: false,
                    route_to_coder: true,
                    route_to_claims_editor: null,
                    pre_prediction_process_reason: "Invalid Case:Correction Before Final",
                    post_prediction_process_reason: null,
                    automate_decision_reason: null,
                    termination_indicator: false,
                    study_indicator: false,
                    automation_eligible: false,
                    can_automate: false,
                    decoration: '{"Customer":["Addendum"],"Invalid Case":["Correction Before Final"]}',
                    hold_billing: true,
                    hold_billing_reason: "WORKQUEUE",
                    release_billing_reason: null,
                    release_to_billing: false,
                    release_to_coder: false,
                    rules: '{"Customer":[{"decoration_category":"Customer","decoration_subcategory":"Addendum","decoration_description":"Default Addendum"}],"Invalid Case":[{"decoration_category":"Invalid Case","decoration_subcategory":"Correction Before Final","decoration_description":"Amendment or Addendum before Final"}]}',
                    process: null,
                    phase: "LIVE",
                    algorithm: "einstein",
                    environment: "development",
                    provenance: "CmxCaseBuilder",
                    ml_function: "radiology-prediction",
                    ml_version: "5.0.0",
                    rule_evaluation_results: [],
                    bpm_process_id: "69758ab7-bfc7-11eb-ac60-f2622926b8d1",
                    case_s3_uri: null,
                    batch_s3_uri: null,
                    prediction_s3_uri: null,
                    external_id: "ST-20210528101433-005",
                    billing_export_id: null,
                    cac_export_id: 8981,
                    billing_group_id: 7861,
                    export_group_id: null,
                    resubmit_date: null,
                    submitter_process: null,
                    submitted_primary_clinical_identifier: null,
                    prediction_job_id: null,
                    hl7_insurance_plan_id: null,
                    hl7_insurance_plan_text: null,
                    hl7_insurance_payer_id: null,
                    hl7_insurance_payer_name: null,
                    hl7_insurance_plan_type: null,
                    scenario: null,
                    case_type: null,
                    specialty: null
                }
            ]
        },
        {
            id: 14750,
            caseRuns: [
                {
                    case_id: 14750,
                    case_status: "Manual",
                    process_instance_id: 16763,
                    case_encounter_id: 10256,
                    process_status: "At Coder",
                    run_type: "prediction",
                    primary_process_indicator: true,
                    source_type: "HL7",
                    service_line: "Radiology",
                    tenant_code: "MGH",
                    tenant_name: "Massachusetts General Hospital",
                    tenant_timezone: "America/New_York",
                    health_system_code: "PHS",
                    patient_id: 204001,
                    patient_name: "SCENARIO14, JESSICA",
                    date_of_birth: "1981-08-18",
                    patient_gender: "F",
                    patient_identifier: {
                        number: "934938",
                        issuer: "EPIC",
                        type: "PMRN"
                    },
                    visit_number: {
                        number: "3305157793",
                        issuer: "EPIC",
                        type: "VISIT_NUMBER"
                    },
                    account_number: {
                        number: "6122578737",
                        issuer: null,
                        type: null
                    },
                    patient_class: "OUTPATIENT",
                    patient_type: null,
                    reason_for_visit: "*Ankle pain, osteochondral lesion suspected, neg xray",
                    primary_insurance: null,
                    primary_insurance_category: null,
                    encounter_identifier: {
                        number: "3305157793-2021-05-27-261142",
                        issuer: "CMX",
                        type: "ENCOUNTER_NUMBER"
                    },
                    exam_description: "MRI ANKLE WITHOUT CONTRAST (RIGHT)",
                    point_of_care: "MGH_IMGMRNS",
                    place_of_service: "MGDAN",
                    order_control: "RE",
                    order_number: {
                        number: "673003612",
                        issuer: "EPC",
                        type: "ORDER_NUMBER"
                    },
                    order_placer_number: {
                        number: "673003612",
                        issuer: "EPC",
                        type: "ORDER_NUMBER"
                    },
                    order_filler_number: {
                        number: "E15646483",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    ordering_provider_name: "CHIODO, CHRISTOPHER",
                    ordering_provider_specialty: null,
                    ordering_provider_number: {
                        number: "1002728",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    primary_clinical_identifier: {
                        number: "E15646483",
                        issuer: "EPC",
                        type: "ACCESSION_NUMBER"
                    },
                    division: "MGDAN",
                    exam_code: "MR.MS.ANK-/R",
                    body_region: "Lower Extremity",
                    procedure_type: "Magnetic Resonance",
                    procedure_type_category: "MR",
                    customer_automation_decision: null,
                    date_of_service: "2021-05-27",
                    datetime_of_service: "2021-05-27 11:43:14 EDT",
                    exam_date: null,
                    exam_datetime: null,
                    result_status: "F",
                    billing_location: "MGDAN",
                    billing_area: null,
                    billing_provider_specialty: null,
                    billing_provider_name: "ROSENTHAL, DANIEL",
                    billing_provider_number: {
                        number: "1001657",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    billing_provider_assistant_name: null,
                    billing_provider_assistant_number: null,
                    scheduling_department: "MGH IMG MR NS",
                    scheduling_department_code: "MGH_IMGMRNS",
                    resource_name: "MGH MR1NS",
                    resource_code: "MR1NS",
                    relevant_clinical_info: null,
                    placer_field_2: null,
                    work_queue_name: "MR UPPER/LOWER EXT JOINT",
                    billing_patient_identifier: null,
                    attending_provider_specialty: null,
                    attending_provider_name: null,
                    attending_provider_number: null,
                    referring_provider_specialty: null,
                    referring_provider_name: "CHIODO, CHRISTOPHER",
                    referring_provider_number: {
                        number: "1002728",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    rendering_provider_specialty: null,
                    rendering_provider_name: "ROSENTHAL, DANIEL",
                    rendering_provider_number: {
                        number: "1001657",
                        issuer: "EPIC",
                        type: "EPIC"
                    },
                    admission_datetime: null,
                    discharge_datetime: null,
                    performing_provider_specialty: null,
                    performing_provider_name: null,
                    performing_provider_number: null,
                    service_provider_specialty: null,
                    service_provider_name: null,
                    service_provider_number: null,
                    patient_primary_facility: null,
                    service: null,
                    transaction_id: null,
                    sending_facility: null,
                    claims_edit_enabled_indicator: null,
                    tenant_insurance_plan_id: null,
                    tenant_insurance_plan_text: null,
                    tenant_insurance_payer_id: null,
                    tenant_insurance_payer_name: null,
                    tenant_insurance_payer_number: null,
                    tenant_medicare_contractor: null,
                    cmx_insurance_plan_text: null,
                    cmx_insurance_payer_id: null,
                    cmx_mapped_payer_number: null,
                    cmx_payer_group_name_property_name: null,
                    cmx_payer_category_property_name: null,
                    claims_edit_indicator: null,
                    cci_edit_indicator: null,
                    medicare_jurisdiction: null,
                    medicare_contractor: null,
                    requires_medicaid_cci_edits_indicator: null,
                    requires_cms_cci_edits_indicator: null,
                    requires_ncd_edits_indicator: null,
                    requires_lcd_edits_indicator: null,
                    requires_commercial_edits_indicator: null,
                    requires_mln_edits_indicator: null,
                    requires_article_edits_indicator: null,
                    requires_cms_manual_edits_indicator: null,
                    requires_transmittal_manual_edits_indicator: null,
                    claims_editor_payer_id: null,
                    claims_editor_payer_name: null,
                    claims_editor_issues: null,
                    cci_editor_issues: null,
                    custom_values: { routing: null },
                    mappings: [],
                    artifacts: [],
                    notes: [],
                    case_created_datetime: "2021-05-28 11:14:25 EDT",
                    process_instance_created_datetime: "2021-05-28 11:14:25 EDT",
                    exclusion_datetime: null,
                    prediction_start_datetime: null,
                    added_to_batch_datetime: "2021-05-28 11:15:41 EDT",
                    response_from_batch_datetime: null,
                    prediction_end_datetime: null,
                    automation_decision_datetime: "2021-05-28 12:28:40 EDT",
                    send_to_coder_datetime: null,
                    received_from_coder_datetime: null,
                    send_to_billing_datetime: null,
                    process_instance_completed_datetime: null,
                    case_completed_datetime: null,
                    patient_age: null,
                    prevent_billing_indicator: false,
                    prevent_send_to_coder_indicator: false,
                    automated_indicator: false,
                    route_to_predict: true,
                    route_to_billing: false,
                    route_to_qa: false,
                    route_to_coder: true,
                    route_to_claims_editor: null,
                    pre_prediction_process_reason: null,
                    post_prediction_process_reason: "Do Not Automate:Low Confidence Rule",
                    automate_decision_reason: "RULE",
                    termination_indicator: false,
                    study_indicator: false,
                    automation_eligible: true,
                    can_automate: false,
                    decoration: '{"Do Not Automate":["Low Confidence Rule"]}',
                    hold_billing: false,
                    hold_billing_reason: null,
                    release_billing_reason: null,
                    release_to_billing: false,
                    release_to_coder: true,
                    rules: '{"Do Not Automate":[{"decoration_category":"Do Not Automate","decoration_subcategory":"Low Confidence Rule","decoration_description":"Rule Low Confidence"}]}',
                    process: null,
                    phase: "LIVE",
                    algorithm: "einstein",
                    environment: "development",
                    provenance: "CmxCaseBuilder",
                    ml_function: "radiology-prediction",
                    ml_version: "5.0.0",
                    rule_evaluation_results: [],
                    bpm_process_id: "63584b2d-bfc7-11eb-ac60-f2622926b8d1",
                    case_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/cases/16763.json",
                    batch_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/batches/B16763.json",
                    prediction_s3_uri: "s3://process-data.development.app.codametrix.com/prediction/925d57f5-e1f3-4d79-99f4-7a180d1b0b96/batch/1/results_unmapped/results/16763.json",
                    external_id: "ST-20210528101423-003",
                    billing_export_id: null,
                    cac_export_id: 8983,
                    billing_group_id: 7861,
                    export_group_id: null,
                    resubmit_date: null,
                    submitter_process: null,
                    submitted_primary_clinical_identifier: null,
                    prediction_job_id: null,
                    hl7_insurance_plan_id: null,
                    hl7_insurance_plan_text: null,
                    hl7_insurance_payer_id: null,
                    hl7_insurance_payer_name: null,
                    hl7_insurance_plan_type: null,
                    scenario: null,
                    case_type: null,
                    specialty: null
                }
            ]
        }
    ],
    pageable: {
        sort: { sorted: true, unsorted: false, empty: false },
        pageSize: 25,
        pageNumber: 0,
        offset: 0,
        paged: true,
        unpaged: false
    },
    last: true,
    totalPages: 1,
    totalElements: 2,
    sort: { sorted: true, unsorted: false, empty: false },
    first: true,
    numberOfElements: 2,
    size: 25,
    number: 0,
    empty: false
};
exports.SINGLE_CASE = {
    id: 14750,
    caseRuns: [
        {
            case_id: 14750,
            case_status: "Manual",
            process_instance_id: 16763,
            case_encounter_id: 10256,
            process_status: "At Coder",
            run_type: "prediction",
            primary_process_indicator: true,
            source_type: "HL7",
            service_line: "Radiology",
            tenant_code: "MGH",
            tenant_name: "Massachusetts General Hospital",
            tenant_timezone: "America/New_York",
            health_system_code: "PHS",
            patient_id: 204001,
            patient_name: "SCENARIO14, JESSICA",
            date_of_birth: "1981-08-18",
            patient_gender: "F",
            patient_identifier: {
                number: "934938",
                issuer: "EPIC",
                type: "PMRN"
            },
            visit_number: {
                number: "3305157793",
                issuer: "EPIC",
                type: "VISIT_NUMBER"
            },
            account_number: {
                number: "6122578737",
                issuer: null,
                type: null
            },
            patient_class: "OUTPATIENT",
            patient_type: null,
            reason_for_visit: "*Ankle pain, osteochondral lesion suspected, neg xray",
            primary_insurance: null,
            primary_insurance_category: null,
            encounter_identifier: {
                number: "3305157793-2021-05-27-261142",
                issuer: "CMX",
                type: "ENCOUNTER_NUMBER"
            },
            exam_description: "MRI ANKLE WITHOUT CONTRAST (RIGHT)",
            point_of_care: "MGH_IMGMRNS",
            place_of_service: "MGDAN",
            order_control: "RE",
            order_number: {
                number: "673003612",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_placer_number: {
                number: "673003612",
                issuer: "EPC",
                type: "ORDER_NUMBER"
            },
            order_filler_number: {
                number: "E15646483",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            ordering_provider_name: "CHIODO, CHRISTOPHER",
            ordering_provider_specialty: null,
            ordering_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            primary_clinical_identifier: {
                number: "E15646483",
                issuer: "EPC",
                type: "ACCESSION_NUMBER"
            },
            division: "MGDAN",
            exam_code: "MR.MS.ANK-/R",
            body_region: "Lower Extremity",
            procedure_type: "Magnetic Resonance",
            procedure_type_category: "MR",
            customer_automation_decision: null,
            date_of_service: "2021-05-27",
            datetime_of_service: "2021-05-27 11:43:14 EDT",
            exam_date: null,
            exam_datetime: null,
            result_status: "F",
            billing_location: "MGDAN",
            billing_area: null,
            billing_provider_specialty: null,
            billing_provider_name: "ROSENTHAL, DANIEL",
            billing_provider_number: {
                number: "1001657",
                issuer: "EPIC",
                type: "EPIC"
            },
            billing_provider_assistant_name: null,
            billing_provider_assistant_number: null,
            scheduling_department: "MGH IMG MR NS",
            scheduling_department_code: "MGH_IMGMRNS",
            resource_name: "MGH MR1NS",
            resource_code: "MR1NS",
            relevant_clinical_info: null,
            placer_field_2: null,
            work_queue_name: "MR UPPER/LOWER EXT JOINT",
            billing_patient_identifier: null,
            attending_provider_specialty: null,
            attending_provider_name: null,
            attending_provider_number: null,
            referring_provider_specialty: null,
            referring_provider_name: "CHIODO, CHRISTOPHER",
            referring_provider_number: {
                number: "1002728",
                issuer: "EPIC",
                type: "EPIC"
            },
            rendering_provider_specialty: null,
            rendering_provider_name: "ROSENTHAL, DANIEL",
            rendering_provider_number: {
                number: "1001657",
                issuer: "EPIC",
                type: "EPIC"
            },
            admission_datetime: null,
            discharge_datetime: null,
            performing_provider_specialty: null,
            performing_provider_name: null,
            performing_provider_number: null,
            service_provider_specialty: null,
            service_provider_name: null,
            service_provider_number: null,
            patient_primary_facility: null,
            service: null,
            transaction_id: null,
            sending_facility: null,
            claims_edit_enabled_indicator: null,
            tenant_insurance_plan_id: null,
            tenant_insurance_plan_text: null,
            tenant_insurance_payer_id: null,
            tenant_insurance_payer_name: null,
            tenant_insurance_payer_number: null,
            tenant_medicare_contractor: null,
            cmx_insurance_plan_text: null,
            cmx_insurance_payer_id: null,
            cmx_mapped_payer_number: null,
            cmx_payer_group_name_property_name: null,
            cmx_payer_category_property_name: null,
            claims_edit_indicator: null,
            cci_edit_indicator: null,
            medicare_jurisdiction: null,
            medicare_contractor: null,
            requires_medicaid_cci_edits_indicator: null,
            requires_cms_cci_edits_indicator: null,
            requires_ncd_edits_indicator: null,
            requires_lcd_edits_indicator: null,
            requires_commercial_edits_indicator: null,
            requires_mln_edits_indicator: null,
            requires_article_edits_indicator: null,
            requires_cms_manual_edits_indicator: null,
            requires_transmittal_manual_edits_indicator: null,
            claims_editor_payer_id: null,
            claims_editor_payer_name: null,
            claims_editor_issues: null,
            cci_editor_issues: null,
            custom_values: { routing: null },
            mappings: [
                {
                    name: "exam_code",
                    value: "MR.MS.ANK-/R",
                    mapped_values: [
                        {
                            name: "work_queue_name",
                            value: "MR UPPER/LOWER EXT JOINT",
                            values: []
                        },
                        {
                            name: "procedure_type",
                            value: "Magnetic Resonance",
                            values: []
                        },
                        { name: "procedure_type_category", value: "MR", values: [] }
                    ]
                }
            ],
            artifacts: [
                {
                    artifact_id: 66004,
                    type: "CLINICAL",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 79074,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                modifiers: {
                                    confidence: 0.0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                },
                                used: false
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 66165,
                    type: "PREDICTION",
                    identifier: "16763",
                    procedures: {
                        automate: true,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 79281,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: 0.99,
                                evidence: [
                                    {
                                        type: "Ngram",
                                        score: 0.02718462309462824,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "contrast comparison",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 29,
                                                    end: 59,
                                                    level: "ngram",
                                                    content: "CONTRAST (RIGHT)\n \n COMPARISON"
                                                },
                                                {
                                                    start: 0,
                                                    end: 104,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)\n \n COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.02718462309462824,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "techniqu without",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 0,
                                                    end: 28,
                                                    level: "ngram",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT"
                                                },
                                                {
                                                    start: 0,
                                                    end: 45,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "contrast comparison",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 29,
                                                    end: 59,
                                                    level: "ngram",
                                                    content: "CONTRAST (RIGHT)\n \n COMPARISON"
                                                },
                                                {
                                                    start: 0,
                                                    end: 104,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)\n \n COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "mri ankl",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 11,
                                                    end: 20,
                                                    level: "ngram",
                                                    content: "MRI ANKLE"
                                                },
                                                {
                                                    start: 0,
                                                    end: 45,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "techniqu mri",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 0,
                                                    end: 14,
                                                    level: "ngram",
                                                    content: "TECHNIQUE: MRI"
                                                },
                                                {
                                                    start: 0,
                                                    end: 45,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "without comparison",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 21,
                                                    end: 59,
                                                    level: "ngram",
                                                    content: "WITHOUT CONTRAST (RIGHT)\n \n COMPARISON"
                                                },
                                                {
                                                    start: 0,
                                                    end: 104,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)\n \n COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "mri ankl",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 11,
                                                    end: 20,
                                                    level: "ngram",
                                                    content: "MRI ANKLE"
                                                },
                                                {
                                                    start: 0,
                                                    end: 45,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "ankl",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "signal",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 235,
                                                    end: 241,
                                                    level: "ngram",
                                                    content: "signal"
                                                },
                                                {
                                                    start: 209,
                                                    end: 417,
                                                    level: "sentence",
                                                    content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                },
                                                {
                                                    start: 335,
                                                    end: 341,
                                                    level: "ngram",
                                                    content: "signal"
                                                },
                                                {
                                                    start: 209,
                                                    end: 417,
                                                    level: "sentence",
                                                    content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                },
                                                {
                                                    start: 686,
                                                    end: 692,
                                                    level: "ngram",
                                                    content: "signal"
                                                },
                                                {
                                                    start: 648,
                                                    end: 703,
                                                    level: "sentence",
                                                    content: " SOFT TISSUES: Normal muscle bulk and signal intensity."
                                                },
                                                {
                                                    start: 761,
                                                    end: 767,
                                                    level: "ngram",
                                                    content: "signal"
                                                },
                                                {
                                                    start: 750,
                                                    end: 792,
                                                    level: "sentence",
                                                    content: "Normal fat signal within the sinus tarsi. "
                                                },
                                                {
                                                    start: 868,
                                                    end: 874,
                                                    level: "ngram",
                                                    content: "signal"
                                                },
                                                {
                                                    start: 837,
                                                    end: 956,
                                                    level: "sentence",
                                                    content: " Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.020062617441211576,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "ankl contrast",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 15,
                                                    end: 37,
                                                    level: "ngram",
                                                    content: "ANKLE WITHOUT CONTRAST"
                                                },
                                                {
                                                    start: 0,
                                                    end: 45,
                                                    level: "sentence",
                                                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                modifiers: {
                                    confidence: 0.0,
                                    automate: false,
                                    evidence: [],
                                    codes: []
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                },
                                used: true
                            }
                        ],
                        confidence: 0.99
                    },
                    modifiers: {
                        confidence: 0.0,
                        automate: true,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.37,
                        primary_code_confidence: 0.27,
                        primary_predicted_code: "M89.8X7",
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: [
                            {
                                diagnosis_code: "M89.8X7",
                                automate: false,
                                confidence: 0.37,
                                sequence_number: null,
                                type: null,
                                evidence: [
                                    {
                                        type: "Categorical",
                                        score: 0.1878986067254626,
                                        feature: {
                                            category: "Lower Extremity",
                                            field: "body_region",
                                            type: "categorical"
                                        },
                                        type: "Categorical"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.07377781614780574,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "sclerosi",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 406,
                                                    end: 415,
                                                    level: "ngram",
                                                    content: "sclerosis"
                                                },
                                                {
                                                    start: 209,
                                                    end: 417,
                                                    level: "sentence",
                                                    content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                },
                                                {
                                                    start: 935,
                                                    end: 944,
                                                    level: "ngram",
                                                    content: "sclerosis"
                                                },
                                                {
                                                    start: 837,
                                                    end: 956,
                                                    level: "sentence",
                                                    content: " Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.07275338450082132,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "lesion",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.07275338450082132,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "bone",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 121,
                                                    end: 125,
                                                    level: "ngram",
                                                    content: "BONE"
                                                },
                                                {
                                                    start: 120,
                                                    end: 209,
                                                    level: "sentence",
                                                    content: " BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. "
                                                },
                                                {
                                                    start: 203,
                                                    end: 207,
                                                    level: "ngram",
                                                    content: "bone"
                                                },
                                                {
                                                    start: 120,
                                                    end: 209,
                                                    level: "sentence",
                                                    content: " BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. "
                                                },
                                                {
                                                    start: 289,
                                                    end: 293,
                                                    level: "ngram",
                                                    content: "bone"
                                                },
                                                {
                                                    start: 209,
                                                    end: 417,
                                                    level: "sentence",
                                                    content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                },
                                                {
                                                    start: 903,
                                                    end: 907,
                                                    level: "ngram",
                                                    content: "bone"
                                                },
                                                {
                                                    start: 837,
                                                    end: 956,
                                                    level: "sentence",
                                                    content: " Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.06979559986414867,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "comparison foot",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 49,
                                                    end: 68,
                                                    level: "ngram",
                                                    content: "COMPARISON: XR FOOT"
                                                },
                                                {
                                                    start: 48,
                                                    end: 104,
                                                    level: "sentence",
                                                    content: " COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.06760427952353673,
                                        feature: {
                                            slop: 0,
                                            field: "raw_reasonforvisit",
                                            in_order: true,
                                            ngram: "xray",
                                            type: "ngram",
                                            spans: []
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.06760427952353673,
                                        feature: {
                                            slop: 2,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "area signal",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 219,
                                                    end: 241,
                                                    level: "ngram",
                                                    content: "area of high T2 signal"
                                                },
                                                {
                                                    start: 209,
                                                    end: 417,
                                                    level: "sentence",
                                                    content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                },
                                                {
                                                    start: 323,
                                                    end: 341,
                                                    level: "ngram",
                                                    content: "area of low signal"
                                                },
                                                {
                                                    start: 209,
                                                    end: 417,
                                                    level: "sentence",
                                                    content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                },
                                                {
                                                    start: 852,
                                                    end: 874,
                                                    level: "ngram",
                                                    content: "area of high T2 signal"
                                                },
                                                {
                                                    start: 837,
                                                    end: 956,
                                                    level: "sentence",
                                                    content: " Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.06760427952353673,
                                        feature: {
                                            slop: 1,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "comparison foot",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 49,
                                                    end: 68,
                                                    level: "ngram",
                                                    content: "COMPARISON: XR FOOT"
                                                },
                                                {
                                                    start: 48,
                                                    end: 104,
                                                    level: "sentence",
                                                    content: " COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30"
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.06760427952353673,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "lesion",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 1052,
                                                    end: 1058,
                                                    level: "ngram",
                                                    content: "lesion"
                                                },
                                                {
                                                    start: 1016,
                                                    end: 1124,
                                                    level: "sentence",
                                                    content: "The possibility of an osteochondral lesion, Brodie abscess, or even an osteoid osteoma cannot be excluded.\n "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    },
                                    {
                                        type: "Ngram",
                                        score: 0.06760427952353673,
                                        feature: {
                                            slop: 0,
                                            field: "raw_body",
                                            in_order: true,
                                            ngram: "repres",
                                            type: "ngram",
                                            spans: [
                                                {
                                                    start: 368,
                                                    end: 378,
                                                    level: "ngram",
                                                    content: "represents"
                                                },
                                                {
                                                    start: 209,
                                                    end: 417,
                                                    level: "sentence",
                                                    content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                },
                                                {
                                                    start: 979,
                                                    end: 989,
                                                    level: "ngram",
                                                    content: "represents"
                                                },
                                                {
                                                    start: 956,
                                                    end: 1016,
                                                    level: "sentence",
                                                    content: "While this most likely represents an intraosseous ganglion. "
                                                }
                                            ]
                                        },
                                        type: "Ngram"
                                    }
                                ],
                                used: true
                            }
                        ]
                    }
                },
                {
                    artifact_id: 66003,
                    type: "MAPPED",
                    identifier: null,
                    procedures: {
                        automate: false,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 79073,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: false,
                                confidence: -1.0,
                                evidence: [],
                                modifiers: {
                                    confidence: -1.0,
                                    automate: false,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            automate: false,
                                            confidence: -1.0,
                                            sequence_number: 1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0.0,
                                    primary_code_confidence: 0.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: []
                                },
                                used: true
                            }
                        ],
                        confidence: -1.0
                    },
                    modifiers: {
                        confidence: -1.0,
                        automate: false,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: -1.0,
                        primary_code_confidence: -1.0,
                        primary_predicted_code: null,
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                },
                {
                    artifact_id: 66181,
                    type: "ASSEMBLED",
                    identifier: "16763",
                    procedures: {
                        automate: true,
                        evidence: [],
                        codes: [
                            {
                                procedure_id: 79300,
                                procedure_name: null,
                                procedure_code: "73721",
                                type: null,
                                units: 1.0,
                                sequence_number: 1,
                                transaction_id: null,
                                automate: true,
                                confidence: 1.0,
                                evidence: [],
                                modifiers: {
                                    confidence: 0.0,
                                    automate: true,
                                    evidence: [],
                                    codes: [
                                        {
                                            modifier_code: "RT",
                                            automate: false,
                                            confidence: -1.0,
                                            sequence_number: 1,
                                            evidence: [],
                                            used: true
                                        }
                                    ]
                                },
                                diagnoses: {
                                    confidence: 0.37,
                                    primary_code_confidence: -1.0,
                                    primary_predicted_code: null,
                                    automate: false,
                                    type: null,
                                    evidence: [],
                                    codes: [
                                        {
                                            diagnosis_code: "M89.8X7",
                                            automate: false,
                                            confidence: 0.37,
                                            sequence_number: 1,
                                            type: null,
                                            evidence: [
                                                {
                                                    type: "Categorical",
                                                    score: 0.1878986067254626,
                                                    feature: {
                                                        category: "Lower Extremity",
                                                        field: "body_region",
                                                        type: "categorical"
                                                    },
                                                    type: "Categorical"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.07377781614780574,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_body",
                                                        in_order: true,
                                                        ngram: "sclerosi",
                                                        type: "ngram",
                                                        spans: [
                                                            {
                                                                start: 406,
                                                                end: 415,
                                                                level: "ngram",
                                                                content: "sclerosis"
                                                            },
                                                            {
                                                                start: 209,
                                                                end: 417,
                                                                level: "sentence",
                                                                content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                            },
                                                            {
                                                                start: 935,
                                                                end: 944,
                                                                level: "ngram",
                                                                content: "sclerosis"
                                                            },
                                                            {
                                                                start: 837,
                                                                end: 956,
                                                                level: "sentence",
                                                                content: " Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. "
                                                            }
                                                        ]
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.07275338450082132,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "lesion",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.07275338450082132,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_body",
                                                        in_order: true,
                                                        ngram: "bone",
                                                        type: "ngram",
                                                        spans: [
                                                            {
                                                                start: 121,
                                                                end: 125,
                                                                level: "ngram",
                                                                content: "BONE"
                                                            },
                                                            {
                                                                start: 120,
                                                                end: 209,
                                                                level: "sentence",
                                                                content: " BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. "
                                                            },
                                                            {
                                                                start: 203,
                                                                end: 207,
                                                                level: "ngram",
                                                                content: "bone"
                                                            },
                                                            {
                                                                start: 120,
                                                                end: 209,
                                                                level: "sentence",
                                                                content: " BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. "
                                                            },
                                                            {
                                                                start: 289,
                                                                end: 293,
                                                                level: "ngram",
                                                                content: "bone"
                                                            },
                                                            {
                                                                start: 209,
                                                                end: 417,
                                                                level: "sentence",
                                                                content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                            },
                                                            {
                                                                start: 903,
                                                                end: 907,
                                                                level: "ngram",
                                                                content: "bone"
                                                            },
                                                            {
                                                                start: 837,
                                                                end: 956,
                                                                level: "sentence",
                                                                content: " Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. "
                                                            }
                                                        ]
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.06979559986414867,
                                                    feature: {
                                                        slop: 2,
                                                        field: "raw_body",
                                                        in_order: true,
                                                        ngram: "comparison foot",
                                                        type: "ngram",
                                                        spans: [
                                                            {
                                                                start: 49,
                                                                end: 68,
                                                                level: "ngram",
                                                                content: "COMPARISON: XR FOOT"
                                                            },
                                                            {
                                                                start: 48,
                                                                end: 104,
                                                                level: "sentence",
                                                                content: " COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30"
                                                            }
                                                        ]
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.06760427952353673,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_reasonforvisit",
                                                        in_order: true,
                                                        ngram: "xray",
                                                        type: "ngram",
                                                        spans: []
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.06760427952353673,
                                                    feature: {
                                                        slop: 2,
                                                        field: "raw_body",
                                                        in_order: true,
                                                        ngram: "area signal",
                                                        type: "ngram",
                                                        spans: [
                                                            {
                                                                start: 219,
                                                                end: 241,
                                                                level: "ngram",
                                                                content: "area of high T2 signal"
                                                            },
                                                            {
                                                                start: 209,
                                                                end: 417,
                                                                level: "sentence",
                                                                content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                            },
                                                            {
                                                                start: 323,
                                                                end: 341,
                                                                level: "ngram",
                                                                content: "area of low signal"
                                                            },
                                                            {
                                                                start: 209,
                                                                end: 417,
                                                                level: "sentence",
                                                                content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                            },
                                                            {
                                                                start: 852,
                                                                end: 874,
                                                                level: "ngram",
                                                                content: "area of high T2 signal"
                                                            },
                                                            {
                                                                start: 837,
                                                                end: 956,
                                                                level: "sentence",
                                                                content: " Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. "
                                                            }
                                                        ]
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.06760427952353673,
                                                    feature: {
                                                        slop: 1,
                                                        field: "raw_body",
                                                        in_order: true,
                                                        ngram: "comparison foot",
                                                        type: "ngram",
                                                        spans: [
                                                            {
                                                                start: 49,
                                                                end: 68,
                                                                level: "ngram",
                                                                content: "COMPARISON: XR FOOT"
                                                            },
                                                            {
                                                                start: 48,
                                                                end: 104,
                                                                level: "sentence",
                                                                content: " COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30"
                                                            }
                                                        ]
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.06760427952353673,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_body",
                                                        in_order: true,
                                                        ngram: "lesion",
                                                        type: "ngram",
                                                        spans: [
                                                            {
                                                                start: 1052,
                                                                end: 1058,
                                                                level: "ngram",
                                                                content: "lesion"
                                                            },
                                                            {
                                                                start: 1016,
                                                                end: 1124,
                                                                level: "sentence",
                                                                content: "The possibility of an osteochondral lesion, Brodie abscess, or even an osteoid osteoma cannot be excluded.\n "
                                                            }
                                                        ]
                                                    },
                                                    type: "Ngram"
                                                },
                                                {
                                                    type: "Ngram",
                                                    score: 0.06760427952353673,
                                                    feature: {
                                                        slop: 0,
                                                        field: "raw_body",
                                                        in_order: true,
                                                        ngram: "repres",
                                                        type: "ngram",
                                                        spans: [
                                                            {
                                                                start: 368,
                                                                end: 378,
                                                                level: "ngram",
                                                                content: "represents"
                                                            },
                                                            {
                                                                start: 209,
                                                                end: 417,
                                                                level: "sentence",
                                                                content: "A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. "
                                                            },
                                                            {
                                                                start: 979,
                                                                end: 989,
                                                                level: "ngram",
                                                                content: "represents"
                                                            },
                                                            {
                                                                start: 956,
                                                                end: 1016,
                                                                level: "sentence",
                                                                content: "While this most likely represents an intraosseous ganglion. "
                                                            }
                                                        ]
                                                    },
                                                    type: "Ngram"
                                                }
                                            ],
                                            used: true
                                        }
                                    ]
                                },
                                used: true
                            }
                        ],
                        confidence: 1.0
                    },
                    modifiers: {
                        confidence: 0.0,
                        automate: true,
                        evidence: [],
                        codes: []
                    },
                    diagnoses: {
                        confidence: 0.37,
                        primary_code_confidence: 0.27,
                        primary_predicted_code: "M89.8X7",
                        automate: false,
                        type: null,
                        evidence: [],
                        codes: []
                    }
                }
            ],
            notes: [
                {
                    document_id: 30437,
                    unique_document_number: "30437",
                    description: null,
                    content: "TECHNIQUE: MRI ANKLE WITHOUT CONTRAST (RIGHT)\n \n COMPARISON: XR FOOT 3 OR MORE VIEWS (RIGHT) 2020-Apr-30\n \n FINDINGS:\n \n BONE AND CARTILAGE: There is focal marrow replacement within the tarsal navicular bone. A rounded area of high T2 signal intensity is noted almost centrally within the bone surrounded by a more diffuse area of low signal intensity that presumably represents a combination of edema and sclerosis. No definite thinning of the overlying articular cartilage is visible.\n \n TENDONS: Normal medial, posterior, lateral, and Achilles tendons. \n \n LIGAMENTS: Normal medial and lateral ligaments. Intact superior peroneal retinaculum.\n \n SOFT TISSUES: Normal muscle bulk and signal intensity.\n \n OTHER: Tarsal tunnel within normal limits. Normal fat signal within the sinus tarsi. No plantar fascia thickening.\n \n IMPRESSION:\n Focal rounded area of high T2 signal within the tarsal navicular bone surrounded by a mixture of sclerosis and edema. While this most likely represents an intraosseous ganglion. The possibility of an osteochondral lesion, Brodie abscess, or even an osteoid osteoma cannot be excluded.\n \n \n \n \n \n \n \n \n \n Interpreted by:\n Daniel Ira Rosenthal, MD\n \n Signed by:\n Daniel Ira Rosenthal, MD\n 5/1/20\n \n Final result\n",
                    filename: null,
                    type: "RAW",
                    id: null
                }
            ],
            case_created_datetime: "2021-05-28 11:14:25 EDT",
            process_instance_created_datetime: "2021-05-28 11:14:25 EDT",
            exclusion_datetime: null,
            prediction_start_datetime: null,
            added_to_batch_datetime: "2021-05-28 11:15:41 EDT",
            response_from_batch_datetime: null,
            prediction_end_datetime: null,
            automation_decision_datetime: "2021-05-28 12:28:40 EDT",
            send_to_coder_datetime: null,
            received_from_coder_datetime: null,
            send_to_billing_datetime: null,
            process_instance_completed_datetime: null,
            case_completed_datetime: null,
            patient_age: null,
            prevent_billing_indicator: false,
            prevent_send_to_coder_indicator: false,
            automated_indicator: false,
            route_to_predict: true,
            route_to_billing: false,
            route_to_qa: false,
            route_to_coder: true,
            route_to_claims_editor: null,
            pre_prediction_process_reason: null,
            post_prediction_process_reason: "Do Not Automate:Low Confidence Rule",
            automate_decision_reason: "RULE",
            termination_indicator: false,
            study_indicator: false,
            automation_eligible: true,
            can_automate: false,
            decoration: '{"Do Not Automate":["Low Confidence Rule"]}',
            hold_billing: false,
            hold_billing_reason: null,
            release_billing_reason: null,
            release_to_billing: false,
            release_to_coder: true,
            rules: '{"Do Not Automate":[{"decoration_category":"Do Not Automate","decoration_subcategory":"Low Confidence Rule","decoration_description":"Rule Low Confidence"}]}',
            process: null,
            phase: "LIVE",
            algorithm: "einstein",
            environment: "development",
            provenance: "CmxCaseBuilder",
            ml_function: "radiology-prediction",
            ml_version: "5.0.0",
            rule_evaluation_results: [],
            bpm_process_id: "63584b2d-bfc7-11eb-ac60-f2622926b8d1",
            case_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/cases/16763.json",
            batch_s3_uri: "s3://process-data.development.app.codametrix.com/casedata/batches/B16763.json",
            prediction_s3_uri: "s3://process-data.development.app.codametrix.com/prediction/925d57f5-e1f3-4d79-99f4-7a180d1b0b96/batch/1/results_unmapped/results/16763.json",
            external_id: "ST-20210528101423-003",
            billing_export_id: null,
            cac_export_id: 8983,
            billing_group_id: 7861,
            export_group_id: null,
            resubmit_date: null,
            submitter_process: null,
            submitted_primary_clinical_identifier: null,
            prediction_job_id: null,
            hl7_insurance_plan_id: null,
            hl7_insurance_plan_text: null,
            hl7_insurance_payer_id: null,
            hl7_insurance_payer_name: null,
            hl7_insurance_plan_type: null,
            scenario: null,
            case_type: null,
            specialty: null
        }
    ]
};
//# sourceMappingURL=billing-groups.js.map